import React from "react";
import { forEach } from "lodash";
import TranslationDropDown, {
  ORIGINAL_LANGUAGE_SIGNIFIER,
} from "./TranslationDropDown";
import { useTranslationService } from "../../hooks/useTranslationService";

interface TranslationControlsProps {
  object_language: string;
  types: string[];
  target_id: string;
  resetTranslation: (language: string) => void;
  translateObject: (
    data: { [key: string]: string },
    language: string,
    type?: string,
  ) => void;
}

export default function TranslationControls({
  types,
  target_id,
  object_language,
  resetTranslation,
  translateObject: componentTranslateObject,
}: TranslationControlsProps) {
  const { translateObject: hookTranslateObject, setLastUsedLanguage } =
    useTranslationService();

  function handleLanguageSelect(
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    language: string,
  ) {
    event.preventDefault();
    setLastUsedLanguage(language);
    forEach(types, (type) => translate(language, type));
  }

  function translate(targetLanguage: string, type: string) {
    if (targetLanguage === ORIGINAL_LANGUAGE_SIGNIFIER) {
      resetTranslation(targetLanguage);
    } else {
      hookTranslateObject(target_id, targetLanguage, type, (data, language) => {
        componentTranslateObject(data, language, type);
      });
    }
  }

  return (
    <TranslationDropDown
      handleLanguageSelect={handleLanguageSelect}
      object_language={object_language}
    />
  );
}
